export enum PlumeProduct {
  HomePass = 'HomePass',
  WorkPass = 'WorkPass',
}

export const PlumeServiceProducts = ['HomePass', 'WorkPass'] as const
export type PlumeServiceProductType = (typeof PlumeServiceProducts)[number]
